module.exports = __webpack_public_path__ + "static/media/section3.2.6452bbf1.jpg";